import * as React from "react";

const OrderDetailsArrowLeft: React.FC = () => {
    return (

        <svg width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.445 8 .877 4.707c-.032-.029-.06-.06-.088-.091l.088.091a1.033 1.033 0 0 1-.238-.332.95.95 0 0 1-.058-.573.938.938 0 0 1 .212-.422l.084-.087L4.445 0H7.06a.949.949 0 0 1-.227.613l-.09.094L4.26 3H13v2H4.259l2.483 2.293A.96.96 0 0 1 7.06 8H4.445z" fill="#006AE3" fillRule="nonzero" />
        </svg>

    );
};

export default React.memo(OrderDetailsArrowLeft);
